<template>
    <div>
        <button
            @click="modalActive = true"
            class="video-modal__button"
        >
            <slot/>
        </button>
        <transition name="fade">
            <div
                v-if="modalActive"
                class="video-modal__modal"
            >
                <button
                    @click="modalActive = false"
                    class="video-modal__close"
                >
                    <svg class="video-modal__close-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.967 66.236">
                        <circle cx="36.483" cy="33.118" r="25" fill="none"/>
                        <circle cx="36.483" cy="33.118" r="25" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                        <line x1="29.783" y1="26.418" x2="44.283" y2="40.918" fill="none" stroke="#fff" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
                        <line x1="29.783" y1="40.918" x2="44.283" y2="26.418" fill="none" stroke="#fff" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
                    </svg>
                </button>
                <youtube
                    class="video-modal__video"
                    :video-id="video_id"
                    :player-vars="{ autoplay: 1, modestbranding: 1, showinfo: 0, playsinline: 1, rel: 0 }"/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'VideoModal',
    props: {
        video_id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            modalActive: false,
        };
    },
};
</script>



// WEBPACK FOOTER //
// VideoModal.vue?572ac23e